import {i18n} from '../../../../translate/i18n'
export type TypeSessionOption = {select: string; value: string}

export const typeSessionOptions: TypeSessionOption[] = [
  {select: 'Clean & Safe', value: 'cleanSafe'},
  {select: i18n.t('hospitality_content.type_labels.service'), value: 'service'},
  {select: i18n.t('hospitality_content.type_labels.information'), value: 'information'},
  {
    select: i18n.t('hospitality_content.type_labels.activities_leisure'),
    value: 'activities_leisure',
  },
  {select: i18n.t('hospitality_content.type_labels.bars_restaurants'), value: 'bars_restaurants'},
  {select: i18n.t('hospitality_content.type_labels.schedule'), value: 'schedule'},
  {select: i18n.t('hospitality_content.type_labels.experience'), value: 'experience'},
  {select: i18n.t('hospitality_content.type_labels.booking'), value: 'booking'},
  {select: i18n.t('hospitality_content.type_labels.check_in'), value: 'check_in'},
  {select: i18n.t('hospitality_content.type_labels.check_out'), value: 'check_out'},
  {select: i18n.t('hospitality_content.type_labels.tours'), value: 'tours'},
  {select: i18n.t('hospitality_content.type_labels.feedback'), value: 'feedback'},
]
